// extracted by mini-css-extract-plugin
export default {"thermal":"g2aoNacY","stasis":"uY0DmuOd","arc":"CNGDj_Il","void":"EcezRdSl","strand":"NsxCq26S","prismatic":"J1juTl4U"};